import { createContext } from 'react';

const PrintContext = createContext(null);

export default PrintContext;
